import { Heading, Page, Text, TextLink } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../context/page-context';
import { GridCard } from '../components/GridCard';
import { ListCard } from '../components/ListCard';

export function PartnerContent() {
  const { navigationHandler } = useHandlers();

  return (
    <Page title={t('features:help.pages.help_partner.title')}>
      <div className="flex flex-1 flex-row gap-1">
        <GridCard
          icon="document"
          title={t('features:help.pages.help.help_grid.documentation_and_features.title')}
          body={t('features:help.pages.help.help_grid.documentation_and_features.body')}
          isExternal={true}
          action={() =>
            navigationHandler.navigate('https://docs.sparklayer.io', {
              absolute: true,
              newTab: true,
            })
          }
        />
        <GridCard
          icon="cube"
          title={t('features:help.pages.help_partner.help_grid.api_docs.title')}
          body={t('features:help.pages.help_partner.help_grid.api_docs.body')}
          isExternal={true}
          action={() =>
            navigationHandler.navigate('https://docs.sparklayer.io/sparklayer-api', {
              absolute: true,
              newTab: true,
            })
          }
        />
      </div>

      <Heading level="h2" style="xl">
        {t('features:help.pages.help_partner.faqs.title')}
      </Heading>
      <div className="flex flex-col gap-4">
        <ListCard title={t('features:help.pages.help_partner.faqs.invite_team.title')}>
          <Text>
            {t('features:help.pages.help_partner.faqs.invite_team.body.text')}{' '}
            <TextLink
              onClick={() => {
                navigationHandler.navigate('/settings/team', { excludeSiteEnv: true });
              }}
            >
              {t('features:help.pages.help_partner.faqs.invite_team.body.link')}
            </TextLink>
          </Text>
        </ListCard>
        <ListCard title={t('features:help.pages.help_partner.faqs.refer.title')}>
          <Text>
            {t('features:help.pages.help_partner.faqs.refer.body.text')}{' '}
            <TextLink
              onClick={() =>
                navigationHandler.navigate('https://partners.sparklayer.io/', {
                  absolute: true,
                  newTab: true,
                })
              }
            >
              {t('features:help.pages.help_partner.faqs.partner_portal_link')}
            </TextLink>
          </Text>
        </ListCard>
        <ListCard title={t('features:help.pages.help_partner.faqs.payouts.title')}>
          <Text>
            {t('features:help.pages.help_partner.faqs.payouts.body.text')} {` `}
            <TextLink
              onClick={() =>
                navigationHandler.navigate('https://partners.sparklayer.io/', {
                  absolute: true,
                  newTab: true,
                })
              }
            >
              {t('features:help.pages.help_partner.faqs.partner_portal_link')}
            </TextLink>
          </Text>
        </ListCard>
        <ListCard title={t('features:help.pages.help_partner.faqs.agreement.title')}>
          <Text>
            {t('features:help.pages.help_partner.faqs.agreement.body.text')}{' '}
            <TextLink
              onClick={() =>
                navigationHandler.navigate('https://partners.sparklayer.io/', {
                  absolute: true,
                  newTab: true,
                })
              }
            >
              {t('features:help.pages.help_partner.faqs.partner_portal_link')}
            </TextLink>
          </Text>
        </ListCard>
      </div>
    </Page>
  );
}
